import type {GamesMessages} from "i18n/en/games";
import type {GameId} from "./gameCatalog";

/**
 * The Play button's words, naming the game a transfer picked — React-free, and one Record, so a new game
 * cannot ship without its own label. Read by the Play buttons that offer a transfer's game.
 */
export function playLabel(games: GamesMessages["games"], game: GameId): string {
	const labels: Record<GameId, string> = {
		byte_runner: games.byteRunner.play,
		file_invaders: games.fileInvaders.play,
		pack_the_zip: games.packTheZip.play,
		"2048": games.fileSizes2048.play,
	};
	return labels[game];
}

/** The game's own name, which titles the dialog the success cards open it in (kitecorp/transferify-ui#3320). */
export function gameTitle(games: GamesMessages["games"], game: GameId): string {
	const titles: Record<GameId, string> = {
		byte_runner: games.byteRunner.title,
		file_invaders: games.fileInvaders.title,
		pack_the_zip: games.packTheZip.title,
		"2048": games.fileSizes2048.title,
	};
	return titles[game];
}
